import React from 'react';
import { Star } from 'lucide-react';
import { testimonials } from '../data/mock';

export default function Testimonials() {
  return (
    <section id="depoimentos" className="py-24 lg:py-32 border-t border-[color:var(--gold-500)]/10">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="mb-16 text-center">
          <p className="text-[11px] tracking-widest-2 text-[color:var(--gold-400)] uppercase mb-4">
            Depoimentos
          </p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-[3.4rem] text-[color:var(--cream-100)] leading-tight">
            Quem confia,{' '}
            <span className="italic text-[color:var(--gold-400)]">recomenda.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[color:var(--gold-500)]/15 border border-[color:var(--gold-500)]/15">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-[color:var(--brown-700)] p-8 md:p-10 hover:bg-[color:var(--brown-800)] transition-colors"
            >
              <div className="flex items-center gap-1 mb-6">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star
                    key={s}
                    size={14}
                    className="text-[color:var(--gold-400)]"
                    fill="currentColor"
                  />
                ))}
              </div>
              <p className="font-serif italic text-lg md:text-xl leading-relaxed text-[color:var(--cream-100)]/90">
                {t.text}
              </p>
              <div className="mt-8 pt-6 border-t border-[color:var(--gold-500)]/15">
                <p className="font-medium text-[color:var(--cream-100)]">{t.name}</p>
                <p className="text-sm text-[color:var(--gold-400)]/85 mt-1">{t.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
